
import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import uuid from 'uuid/v4';

import Step from './Step';
import '../styles/_step-loader.scss';

const renderSteps = (steps, currentStep) => steps.map((step, index) =>
<Step
  key={uuid()}
  stepLabel={step.stepLabel}
  isActive={step.isActive}
  needSeparator={index < steps.length - 1}
  stepNumber={index + 1}
  finished={index < currentStep} />

);

const StepLoader = (props, ref) => {
  const { steps } = props;
  const [currentStep, setCurrentStep] = React.useState(0);
  const [stepsState, setStepsState] = React.useState(steps);

  useEffect(() => {
    if (currentStep > steps.length - 1) {
      setStepsState((prevSteps) => prevSteps.map(
        (step) => ({ ...step, finished: true })));
      return;
    }
    setStepsState((prevSteps) => prevSteps.map((step, index) => ({
      ...step,
      isActive: index === currentStep,
      finished: index < currentStep
    })));
  }, [currentStep]);

  useImperativeHandle(ref, () => ({
    next() {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  }));

  return <div className="step-loader">{renderSteps(stepsState, currentStep)}</div>;
};

export default forwardRef(StepLoader);